import { lazy } from 'react'
import { useAdminAuth } from '@/contexts/AdminAuthContext'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

// Lazy load NotFound to avoid circular dependencies
const NotFound = lazy(() => import('@/pages/NotFound'))

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAdminAuth()

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen animated-gradient-bg flex items-center justify-center">
        <LoadingSpinner size="lg" text="Verifying access..." />
      </div>
    )
  }

  // Show 404 if not authenticated - hide admin area existence
  if (!isAuthenticated) {
    return <NotFound />
  }

  // Show 404 if admin role required but user doesn't have it
  if (requireAdmin && user?.role !== 'ADMIN' && user?.role !== 'SUPER_ADMIN') {
    return <NotFound />
  }

  return <>{children}</>
}